class NewsEntriesOverview
    constructor: (el) ->
        @.$el = el
        @.$listEl = @.$el.querySelector '.news-entries-overview ul'
        @.$paginationEl = @.$el.querySelector '.news-entries-overview__pagination'

        @.amount = @.$el.dataset?.amount ? 7
        @.amount = parseInt @.amount, 10
        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.linkableElements = @.$el.classList.contains 'news-entries-overview--le'
        @.mediatype = if @.$el.dataset?.mediatype then (if @.$el.dataset?.mediatype != '' then @.$el.dataset?.mediatype else null) else null
        @.offset = 0
        @.results = []
        @.totalResults = 0

        if @.api && @.apiMethod
            @.GetData()
        else
            @.AppendResults()
        @.InitEvents()
        @.$el.classList.add 'news-entries-overview--bound'
        return

    AppendResults: ->
        self = @
        @.$listEl.innerHTML = ""
        if @.results.length > 0
            @.results.forEach (newsEntry) ->
                newsEntryEl = window.CreateNewsEntry {
                    kicker: newsEntry.kicker ? (if newsEntry['article_publish_date'] then window.appUtils.TimestampToDate(newsEntry['article_publish_date']))
                    headline: newsEntry.headline ? newsEntry['article_title']
                    link: newsEntry.link ? newsEntry['slug']
                    linkableElement: self.linkableElements
                    linkText: newsEntry.linkText
                    text: newsEntry.text ? newsEntry['article_abstract']
                }
                self.$listEl.appendChild newsEntryEl
                return
            window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        return

    GetData: ->
        if @.apiMethod == 'GET' || @.apiMethod == 'POST'
            self = @
            try
                if @.apiMethod == 'POST'
                    body = {
                        amount: @.amount
                        mediatype: @.mediatype ? "-1"
                        offset: @.offset
                    }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                                totalResults = parseInt answer.total, 10
                                self.results = answer.results
                                self.actual = self.results.length
                                if self.totalResults != totalResults
                                    self.totalResults = totalResults
                                    self.$paginationEl.dispatchEvent new CustomEvent 'pagination-update-pages', {
                                        bubbles: false
                                        detail: {
                                            pagesCount: Math.ceil(self.totalResults / self.amount)
                                        }
                                    }
                                if self.totalResults < 1
                                    self.$el.classList.add 'news-entries-overview--none-results'
                            catch error
                                console.log "Fehler beim Versuch die News-Datenquelle zu verarbeiten"
                                self.AppendResults()
                                self.$el.classList.add 'news-entries-overview--none-results'
                                return
                        else
                            console.log "Die Anfrage der News-Datenquelle lieferte ein leeres Ergebnis"
                            self.$el.classList.add 'news-entries-overview--none-results'
                        self.AppendResults()
                    , ->
                        self.AppendResults()
                        self.$el.classList.add 'news-entries-overview--none-results'
                        console.log "Bei der Anfrage an die News-Datenquelle ist leider ein Fehler aufgetreten"
                        return
                    , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Fehler beim Versuch die News-Datenquelle zu ermitteln"
                self.AppendResults()
                self.$el.classList.add 'news-entries-overview--none-results'
        else
            try
                if window[@.api]
                    @.results = window[@.api]  
                else
                    console.log "Die News-Datenquelle konnte nicht ermittelt werden"
                    self.$el.classList.add 'news-entries-overview--none-results'
                @.AppendResults()
            catch error
                console.log "Fehler beim Versuch die News-Datenquelle zu verarbeiten"
                @.AppendResults()
                self.$el.classList.add 'news-entries-overview--none-results'
        return

    InitEvents: ->
        self = @
        if @.$paginationEl
            @.$paginationEl.addEventListener 'pagination-active-page-set', (e) ->
                actualPage = if e.detail?.activePage then parseInt(e.detail.activePage,10) else 1
                self.offset = (actualPage - 1) * self.amount
                self.GetData()
                self.ScrollToElTop()
                return
        return
    
    ScrollToElTop: ->
        bodyRect = document.body.getBoundingClientRect()
        elRect = @.$el.getBoundingClientRect()
        window.scrollTo {
            behavior: 'smooth',
            left: 0,
            top: elRect.top - bodyRect.top
        }
        return

BindNewsEntriesOverviews = ->
    document.querySelectorAll '.news-entries-overview:not(.news-entries-overview--bound)'
        .forEach (el) ->
            new NewsEntriesOverview el
            return
    return

window.addEventListener 'bind-components', BindNewsEntriesOverviews